import PigGroupMovementsContainer from './PigGroupMovementsContainer';

export default PigGroupMovementsContainer;
